import React, { Component } from 'react'
import AWSAPI from '../../../common/AWSAPI'
import Window from '../../../common/Window'
import Loading from '../../../common/component/Loading'
import Config from '../../../Config'
import AWS from 'aws-sdk'

class SharedFileEdit extends Component {
  constructor (props) {
    super(props)
    this.state = this.getInitialState()
    this.apiUrl = Config.adminApiUrl.systemSettings
    this.userRoleUrl = 'admin'
    this.userRole = 'admin'
  }
  getInitialState () {
    const dt = new Date()
    return {
      isSharedFileCategorySettingLoaded: false,
      isSharedFileSettingLoaded: false,
      isNew: true,
      id: null,
      categoryId: '',
      year: dt.getFullYear(),
      month: dt.getMonth() + 1,
      day: dt.getDate(),
      hour: dt.getHours(),
      minutes: (Math.floor(dt.getMinutes() / 15) * 15),
      title: '',
      filename: null,
      description: ''
    }
  }
  componentWillMount () {
    const {params} = this.props.match
    const id = params.id
    this.loadSharedFileCategorySetting()
    if (id) {
      this.loadSharedFile(id)
    } else {
      const initialState = this.getInitialState()
      this.setState(initialState)
      this.setState({
        isSharedFileSettingLoaded: true
      })
    }
  }
  loadSharedFileCategorySetting () {
    const onSuccess = (res) => {
      const systemSettingValue = res.body.data.systemSettingValue
      this.setState({
        isSharedFileCategorySettingLoaded: true,
        SharedFileCategorySetting: systemSettingValue
      })
    }
    const params = {
      command: 'get',
      systemSettingName: 'SharedFileCategorySetting'
    }
    AWSAPI.apiPost(this.userRole, this.apiUrl, params, onSuccess)
  }
  loadSharedFile (id) {
    const onSuccess = (res) => {
      const {params} = this.props.match
      const id = params.id
      const sharedFile = res.body.data.systemSettingValue.filter((e) => e.id === id)[0]
      this.setState({
        isSharedFileSettingLoaded: true,
        isNew: false,
        id: sharedFile.id,
        categoryId: sharedFile.categoryId,
        year: sharedFile.year,
        month: sharedFile.month,
        day: sharedFile.day,
        hour: sharedFile.hour,
        minutes: sharedFile.minutes,
        title: sharedFile.title,
        description: sharedFile.description,
        filename: sharedFile.filename
      })
    }
    const params = {
      command: 'get',
      systemSettingName: 'SharedFileSetting'
    }
    AWSAPI.apiPost(this.userRole, this.apiUrl, params, onSuccess)
  }

  saveSharedFile () {
    const sharedFile = this.state
    sharedFile.title = sharedFile.title.trim()
    if (sharedFile.year < 1000) {
      Window.alert('西暦を4桁で入力してください')
      return false
    }
    const originalDate = sharedFile.year + '/' + sharedFile.month + '/' + sharedFile.day
    const jsDate = new Date(originalDate)
    if (originalDate !== (jsDate.getFullYear() + '/' + (jsDate.getMonth() + 1) + '/' + jsDate.getDate())) {
      Window.alert('存在しない日付です')
      return false
    }
    if (sharedFile.title === '') {
      Window.alert('表示名は必須です')
      return false
    }
    if (!sharedFile.file && this.state.isNew) {
      Window.alert('共有ファィルのアップロードは必須です')
      return false
    }
    const userPool = AWSAPI.getUserPool('admin')
    var cognitoUser = userPool.getCurrentUser()

    const saveMetaData = () => {
      const {params} = this.props.match
      const id = params.id
      const sharedFile = this.state
      let updateOrInsert
      if (id) { // 更新
        updateOrInsert = (oldSystemSettingValue) => {
          const systemSettingValue = []
          oldSystemSettingValue.forEach((e) => {
            const result = {}
            if (e.id === id) {
              result.id = sharedFile.id
              result.categoryId = sharedFile.categoryId
              result.year = parseInt(sharedFile.year, 10)
              result.month = parseInt(sharedFile.month, 10)
              result.day = parseInt(sharedFile.day, 10)
              result.hour = parseInt(sharedFile.hour, 10)
              result.minutes = parseInt(sharedFile.minutes, 10)
              result.title = sharedFile.title
              result.description = sharedFile.description ? sharedFile.description : null
              result.filename = sharedFile.filename
            } else {
              result.id = e.id
              result.categoryId = e.categoryId
              result.year = e.year
              result.month = e.month
              result.day = e.day
              result.hour = e.hour
              result.minutes = e.minutes
              result.title = e.title
              result.description = e.description ? e.description : null
              result.filename = e.filename
            }
            systemSettingValue.push(result)
          })
          return systemSettingValue
        }
      } else { // 新規登録
        updateOrInsert = (oldSystemSettingValue) => {
          const systemSettingValue = oldSystemSettingValue.slice()
          const result = {
            id: this.uuid(),
            categoryId: sharedFile.categoryId,
            year: parseInt(sharedFile.year, 10),
            month: parseInt(sharedFile.month, 10),
            day: parseInt(sharedFile.day, 10),
            hour: parseInt(sharedFile.hour, 10),
            minutes: parseInt(sharedFile.minutes, 10),
            title: sharedFile.title,
            description: sharedFile.description ? sharedFile.description : null,
            filename: sharedFile.filename
          }
          systemSettingValue.push(result)
          return systemSettingValue
        }
      }
      const onSuccessToGet = (res) => {
        const systemSettingValue = updateOrInsert(res.body.data.systemSettingValue)
        const sorter = (a, b) => {
          const dateA = a.year * 100000000 + a.month * 1000000 + a.day * 10000 + a.hour * 100 + a.minutes
          const dateB = b.year * 100000000 + b.month * 1000000 + b.day * 10000 + b.hour * 100 + b.minutes
          if (dateA < dateB) return 1
          if (dateA > dateB) return -1
          return 0
        }
        const paramsToSet = {
          command: 'set',
          systemSettingName: 'SharedFileSetting',
          systemSettingValue: systemSettingValue.sort(sorter)
        }
        const onSuccessToPost = (res) => {
          Window.alert('保存しました', () => {
            if (this.state.isNew) {
              this.props.history.push('/admin/shared_files')
            } else {
              this.props.history.push('/admin/shared_files/detail/' + id)
            }
            Window.closeDialog()
          })
        }
        AWSAPI.apiPost(this.userRole, this.apiUrl, paramsToSet, onSuccessToPost)
      }
      const paramsToGet = {
        command: 'get',
        systemSettingName: 'SharedFileSetting'
      }
      AWSAPI.apiPost(this.userRole, this.apiUrl, paramsToGet, onSuccessToGet)
    }

    if (sharedFile.file) {
      if (cognitoUser != null) {
        cognitoUser.getSession(function (err, session) {
          if (err) {
            return
          }
          AWS.config.region = 'ap-northeast-1'
          AWS.region = 'ap-northeast-1'
          AWS.config.credentials = new AWS.CognitoIdentityCredentials({
            AccountId: Config.adminSharedfileSetting.AccountId,
            RoleArn: Config.adminSharedfileSetting.RoleArn,
            IdentityPoolId: Config.adminSharedfileSetting.IdentityPoolId,
            Logins: {
              [Config.adminSharedfileSetting.Logins]: session.getIdToken().getJwtToken()
            }
          })
          AWS.config.credentials.refresh((error) => {
            if (error) {
              // console.error(error)
            } else {
              // console.log('Successfully logged!')
            }
          })
          var s3 = new AWS.S3({
            region: 'ap-northeast-1',
            maxRetries: 15
          })

          const paramsToUpload = {
            Bucket: Config.adminSharedfileSetting.Bucket,
            Key: sharedFile.file.name,
            ContentType: sharedFile.type,
            Body: sharedFile.file
          }
          s3.putObject(paramsToUpload, function (err, result) {
            if (err) {
              // return console.log(err)
            } else {
              saveMetaData()
              // return console.log(result)
            }
          })
        })
      }
    } else {
      saveMetaData()
    }
  }
  onPageMenuClicked (name) {
    const id = this.state.id
    switch (name) {
      case 'back':
        if (this.state.isNew) {
          this.props.history.push('/admin/shared_files')
        } else {
          this.props.history.push('/admin/shared_files/detail/' + id)
        }
        break
      default:
        break
    }
  }
  uuid () {
    let uuid = ''
    let i
    let random
    for (i = 0; i < 32; i++) {
      random = Math.random() * 16 | 0

      if (i === 8 || i === 12 || i === 16 || i === 20) {
        uuid += '-'
      }
      uuid += (i === 12 ? 4 : (i === 16 ? ((random & 3) | 8) : random)).toString(16)
    }
    return uuid
  }
  renderSharedFileDetail (state) {
    const sharedFile = state
    const changed = (name, e) => this.setState({[name]: e.target.value})
    const changeFile = (e) => {
      if (!e.target.files) {
        e.preventDefault()
        return false
      }
      const file = e.target.files.item(0)
      if (file) {
        this.setState({
          file: file,
          filename: file.name
        })
      }
    }
    const title = state.isNew ? '新規登録' : '変更'
    const sharedFileCategorySelector = this.state.SharedFileCategorySetting.map((sharedFileCategory) => {
      return (
        <option key={sharedFileCategory.id} value={sharedFileCategory.id}>{sharedFileCategory.name}</option>
      )
    })
    if (state.isNew && sharedFile.categoryId === '') {
      sharedFile.categoryId = this.state.SharedFileCategorySetting[0].id
    }
    return (
      <fieldset>
        <legend>事務局からの共有ファイル - {title}</legend>
        <br />
        <div className='control-group row'>
          <label className='span3'>カテゴリ <span className='required'>*</span></label>
          <div className='span5'>
            <select className='span5' value={sharedFile.categoryId} onChange={e => changed('categoryId', e)}>
              {sharedFileCategorySelector}
            </select>
          </div>
        </div>
        <div className='control-group row'>
          <label className='span3'>公開日 <span className='required'>*</span></label>
          <div className='span13'>
            西暦 <input className='span2' type='text' value={sharedFile.year} onChange={e => changed('year', e)} />
            <span className='kw-info-unit'>年</span>
            <select className='span2' value={sharedFile.month} onChange={e => changed('month', e)}>
              <option value='1'>01</option>
              <option value='2'>02</option>
              <option value='3'>03</option>
              <option value='4'>04</option>
              <option value='5'>05</option>
              <option value='6'>06</option>
              <option value='7'>07</option>
              <option value='8'>08</option>
              <option value='9'>09</option>
              <option value='10'>10</option>
              <option value='11'>11</option>
              <option value='12'>12</option>
            </select>
            <span className='kw-info-unit'>月</span>
            <select className='span2' value={sharedFile.day} onChange={e => changed('day', e)}>
              <option value='1'>01</option>
              <option value='2'>02</option>
              <option value='3'>03</option>
              <option value='4'>04</option>
              <option value='5'>05</option>
              <option value='6'>06</option>
              <option value='7'>07</option>
              <option value='8'>08</option>
              <option value='9'>09</option>
              <option value='10'>10</option>
              <option value='11'>11</option>
              <option value='12'>12</option>
              <option value='13'>13</option>
              <option value='14'>14</option>
              <option value='15'>15</option>
              <option value='16'>16</option>
              <option value='17'>17</option>
              <option value='18'>18</option>
              <option value='19'>19</option>
              <option value='20'>20</option>
              <option value='21'>21</option>
              <option value='22'>22</option>
              <option value='23'>23</option>
              <option value='24'>24</option>
              <option value='25'>25</option>
              <option value='26'>26</option>
              <option value='27'>27</option>
              <option value='28'>28</option>
              <option value='29'>29</option>
              <option value='30'>30</option>
              <option value='31'>31</option>
            </select>
            <span className='kw-info-unit'>日</span>
          </div>
        </div>
        <div className='control-group row'>
          <label className='span3'>公開時刻 <span className='required'>*</span></label>
          <div className='span13 row'>
            <select className='span2' value={sharedFile.hour} onChange={e => changed('hour', e)}>
              <option value='0'>00</option>
              <option value='1'>01</option>
              <option value='2'>02</option>
              <option value='3'>03</option>
              <option value='4'>04</option>
              <option value='5'>05</option>
              <option value='6'>06</option>
              <option value='7'>07</option>
              <option value='8'>08</option>
              <option value='9'>09</option>
              <option value='10'>10</option>
              <option value='11'>11</option>
              <option value='12'>12</option>
              <option value='13'>13</option>
              <option value='14'>14</option>
              <option value='15'>15</option>
              <option value='16'>16</option>
              <option value='17'>17</option>
              <option value='18'>18</option>
              <option value='19'>19</option>
              <option value='20'>20</option>
              <option value='21'>21</option>
              <option value='22'>22</option>
              <option value='23'>23</option>
            </select>
            <span className='kw-info-unit'>時</span>
            <select className='span2' value={sharedFile.minutes} onChange={e => changed('minutes', e)}>
              <option value='0'>00</option>
              <option value='15'>15</option>
              <option value='30'>30</option>
              <option value='45'>45</option>
            </select>
            <span className='kw-info-unit'>分</span>
          </div>
        </div>
        <div className='control-group row'>
          <label className='span3'>表示名 <span className='required'>*</span></label>
          <div className='span4'>
            <input type='text' name='informationBody' className='span4' value={sharedFile.title} onChange={e => changed('title', e)} />
          </div>
        </div>
        <div className='control-group row'>
          <label className='span3'>説明</label>
          <div className='span10'>
            <textarea name='informationBody' className='span10' value={sharedFile.description ? sharedFile.description : ''} onChange={e => changed('description', e)} />
          </div>
        </div>
        <div className='control-group row'>
          <label className='span3'>共有ファイル <span className='required'>*</span></label>
          <div className='span13'>
            <p style={{color: 'red'}}>ファイル名は英語かローマ字で空白をあけない連続した文字列のものにしてください。</p>
            <dl><dt>現在のファイル: </dt><dd>{sharedFile.filename ? sharedFile.filename : '(無し)'}</dd></dl>
            <input type='file' id='sharedFileName' name='sharedFileName' className='span13' style={{display: 'none'}}onChange={e => changeFile(e)} />
            <button className='btn btn-small btn-info' onClick={(e) => this.onFormButtonClicked('upload', e)} >アップロード</button>
          </div>
        </div>
      </fieldset>
    )
  }
  onFormButtonClicked (name, e) {
    e.preventDefault()
    const id = this.state.id
    switch (name) {
      case 'upload':
        const e = document.getElementById('sharedFileName')
        e.click()
        break
      case 'save':
        this.saveSharedFile()
        break
      case 'cancel':
        if (this.state.isNew) {
          this.props.history.push('/admin/shared_files')
        } else {
          this.props.history.push('/admin/shared_files/detail/' + id)
        }
        break
      default:
        break
    }
  }
  render () {
    if (!this.state.isSharedFileCategorySettingLoaded ||
        !this.state.isSharedFileSettingLoaded) {
      return <Loading />
    }
    const sharedFileDetail = this.renderSharedFileDetail(this.state)
    const title = this.state.isNew ? '新規登録' : '変更'
    return (
      <div>
        <section className='nav-page'>
          <div className='container'>
            <div className='row'>
              <div className='span7'>
                <header className='page-header'>
                  <h3>事務局からの共有ファイル - {title}<br /><small>こちらで事務局からの共有ファイルを{title}できます。</small></h3>
                </header>
              </div>
              <div className='span9'>
                <ul className='nav nav-pills'>
                  <li className='kw-btn-area'><button rel='tooltip' data-placement='left' title='戻る' className='text-center kw-btn-primary' onClick={(e) => this.onPageMenuClicked('back')}><i className='icon-arrow-left icon-large' /><span>戻る</span></button></li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        <section className='page container'>
          <form className='form-horizontal' method='post'>
            <div className='container'>
              <div className='kw-ic-info-regist-area span16'>
                <div className='alert alert-block alert-info'>
                  <p>必要な情報を入力して最後に「保存」ボタンを押してください。「<span className='required'>*</span>」マークは必須項目です。</p>
                </div>
                {sharedFileDetail}
                <footer className='form-actions' id='submit-actions'>
                  <button className='btn btn-primary' onClick={(e) => this.onFormButtonClicked('save', e)} >保存</button>
                  <button className='btn btn-default' onClick={(e) => this.onFormButtonClicked('cancel', e)}>キャンセル</button>
                </footer>
              </div>
            </div>
          </form>
        </section>
      </div>
    )
  }
}

export default SharedFileEdit



// WEBPACK FOOTER //
// ./src/admin/pages/secure/SharedFileEdit.js